// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"8940015e57b41b9a467a","4545":"4650ff5dd420d0145391","6083":"4650ff5dd420d0145391","9173":"4650ff5dd420d0145391"}[chunkId] + ".css";
};